import { FieldTypeEnum } from "@/core/enums/field-types";

const fields = {
  escopo: [
    {
      key: "id_projeto",
      name: `Sigla`,
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      rules: [{ rule: "required" }],
      labelBold: true,
      nao_comenta: true,
    },
    {
      key: "titulo",
      name: `Nome do Projeto`,
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "min", params: { size: 3 } }, { rule: "max", params: { size: 250 } }],
      counter: 250,
      maxLength: 250,
      nao_comenta: true,
    },
    {
      key: "titulo_transmissao",
      name: `Nome do Projeto para Transmissão`,
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "min", params: { size: 3 } }, { rule: "max", params: { size: 250 } }],
      counter: 250,
      maxLength: 250,
      nao_comenta: true,
    },
    {
      key: "trabalho",
      name: "Benefício",
      type: FieldTypeEnum.SELECT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: { to: "trabalho", key: "id", name: "nome" },
    },
    {
      key: "status",
      name: "Status",
      type: FieldTypeEnum.SELECT,
      habilita_comentario: true,
      labelBold: true,
      rel: { to: "status", key: "id", name: "label" },
      colSize: 6,
    },
    {
      key: "data_inicio",
      name: "Data de Início",
      type: FieldTypeEnum.DATE,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      nao_comenta: true,
    },
    {
      key: "data_fim",
      name: "Data/Previsão de Término",
      type: FieldTypeEnum.DATE,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      nao_comenta: true,
    },
    {
      key: "ano_base",
      name: "Ano-base",
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      nao_comenta: true,
    },
  ],
  classificacao: [
    {
      key: "tipo_projetoId",
      name: "Tipo (Escolha uma das opções)",
      type: FieldTypeEnum.RADIO,
      habilita_comentario: true,
      outline: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: { to: "tipoProjeto", key: "id", name: "descricao" },
    },
    {
      key: "troca_ppb",
      name: `Projeto para cumprir troca de PPB por P,D&I? (Escolha uma das opções)`,
      type: FieldTypeEnum.RADIO,
      habilita_comentario: true,
      outline: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: {
        key: "id",
        name: "descricao",
        to: [
          { id: "Sim", descricao: "Sim" },
          { id: "Nao", descricao: "Não" },
        ],
      },
    },
    {
      key: "alcance",
      name: "Alcance (pode ser marcado mais de uma opção)",
      type: FieldTypeEnum.CHECKBOXES,
      habilita_comentario: true,
      outline: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: { to: "alcance", key: "id", name: "descricao" },
    },
    {
      key: "inovacao",
      name: "Grau de Inovação - Abrangência (pode ser marcado mais de uma opção)",
      type: FieldTypeEnum.CHECKBOXES,
      habilita_comentario: true,
      outline: true,
      labelBold: true,
      itemsPerLine: 3,
      rules: [{ rule: "required" }],
      rel: { to: "inovacao", key: "id", name: "descricao" },
    },
    {
      key: "inovacao_desenvolvimento",
      name: "Grau de Inovação - Desenvolvimento (pode ser marcado mais de uma opção)",
      type: FieldTypeEnum.CHECKBOXES,
      habilita_comentario: true,
      outline: true,
      labelBold: true,
      itemsPerLine: 3,
      rules: [{ rule: "required" }],
      rel: {
        to: [
          { id: 1, descricao: "Aprimoramentos a partir de algo existente." },
          { id: 2, descricao: "Desenvolvimento de algo novo." },
        ],
        key: "id", name: "descricao"
      },
    },
    {
      key: "area_aplicacaoId",
      name: "Área de Aplicação (escolha uma das opções)",
      type: FieldTypeEnum.SELECT,
      habilita_comentario: true,
      labelBold: true,
      itemsPerLine: 1,
      rules: [{ rule: "required" }],
      rel: { to: "areaAplicacao", key: "id", name: "descricao" },
    },
    {
      key: "possui_publicacoes",
      name: `Possui publicações?`,
      type: FieldTypeEnum.RADIO,
      habilita_comentario: true,
      outline: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: {
        key: "id",
        name: "descricao",
        to: [
          { id: "Sim", descricao: "Sim" },
          { id: "Nao", descricao: "Não" },
        ],
      },
    },
    {
      key: "qtde_publicacoes",
      name: "Quantidade de Publicações",
      type: FieldTypeEnum.NUMBER,
      habilita_comentario: true,
      rules: [{ rule: "required" }],
      labelBold: true,
      condition: (projeto) => projeto.possui_publicacoes === 'Sim',
    },
    {
      key: "decreto",
      name: "Artigo 2º",
      type: FieldTypeEnum.CHECKBOXES,
      habilita_comentario: true,
      labelBold: true,
      outline: true,
      rules: [{ rule: "required" }],
      rel: {
        key: "id",
        name: "descricao",
        to: [
          { id: 1, descricao: "I - pesquisa básica - pesquisa experimental ou teórica executada primariamente para a aquisição de conhecimento novo sobre os fundamentos subjacentes aos fenômenos e fatos observáveis, sem qualquer aplicação particular ou uso em vista;" },
          { id: 2, descricao: "II - pesquisa aplicada - pesquisa original realizada com o objetivo de adquirir conhecimento e que dirige-se primariamente a um objetivo ou a um alvo prático específico;" },
          { id: 3, descricao: "III - desenvolvimento experimental - trabalho sistemático, baseado em conhecimento preexistente e destinado à produção de novos produtos e processos ou ao aperfeiçoamento dos produtos e processos existentes;" },
        ],
      },
    },
    // {
    //   key: "keyword_li",
    //   name: "Palavra-chave",
    //   type: FieldTypeEnum.TEXT,
    //   labelBold: true,
    //   rules: [],
    // },
  ],
  objetivos: [
    {
      key: "descricao_li",
      name: `Objetivo do Projeto`,
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      ajudaComplexo: `Neste item é necessário descrever quais foram as motivações que levaram ao desenvolvimento do projeto em questão. <br><br> Também é necessário descrever os objetivos deste novo desenvolvimento, mostrando quais os resultados esperados ao final do projeto.<br><br> Esses pontos devem ser descritos de forma realista, coerente com os objetivos e estratégias da empresa e traduzindo o que deve ser realizado no projeto.`
    },
    {
      key: "elemento_tecnologico_li",
      name: "Elemento tecnologicamente novo ou inovador",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      ajudaComplexo: `
      <ul>
        <li>Explicar com riqueza de detalhes, quais as principais inovações e novidades que o projeto traz para a empresa e para o mercado.</li><br>
        <li>Realizar comparativo, apresentando quais as vantagens tecnológicas do novo produto com relação ao mercado ou da melhoria com relação ao produto/processo/serviço anterior; </li><br>
        <li>Mensurar ganhos envolvidos (produtividade, performance, eficiência, redução de matéria prima, custos, qualidade etc...)</li><br>
        <li>Descrever tecnologia desenvolvida, com suas novas funcionalidades/características e aplicações; avanços tecnológicos que possibilitaram tais ganhos.</li><br>
        <li>Se aplicável, comentar sobre o antes e o depois do projeto, ou seja, o que existia antes desse projeto, como era feito e quais eram as limitações das soluções existentes.</li>
      </ul>`,
    },
    {
      key: "desafio_tecnologico_li",
      name: "Desafio técnico científico a ser resolvido",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      ajudaComplexo: `
        <p><b>Aqui devem ser apresentados indícios que apontem para a existência de um problema técnico-científico, apresentando:</b></p><br>
      <ul>
        <li>Apresentar os problemas, dificuldades, limitações ou restrição de <b>ordem técnica</b> imposto ao desenvolvimento, compreensão e implementação das novas tecnologias, ou novos conhecimentos. As atividades realizadas para superar o problema devem ser de P&D, que sempre apresentará um resultado, mesmo que seja um indicativo de que a premissa adotada e testada não deve mais ser seguida;</li><br>
        <li>Aprofundar os desafios da equipe em relação ao projeto, ou seja, quais foram as <b>dificuldades/complicações/problemas de ordem técnica</b> enfrentados no desenvolvimento da inovação;</li><br>
        <li>Riscos tecnológicos que envolvem o desenvolvimento do projeto; dificuldades que poderiam ter afetado ou afetaram a execução das atividades; dificuldades no desenvolvimento de insumos e materiais competitivos; restrição de acesso às tecnologias etc;</li><br>
        <li>Explicar qual o impacto dessas dificuldades/complicações/problemas no desenvolvimento projeto. Ou seja, o que poderia ser inviabilizado/restringido/suspenso caso a equipe não superasse a barreira;</li><br>
        <li>Exemplos do que NÃO pode ser considerado barreira para fins de comprovação de atividade de P&D: desafios comerciais e de marketing; problemas culturais e de engajamento de várias equipes; falta de conhecimento técnico para desenvolvimento do projeto; custo final do produto e/ou serviço.</li><br>
      </ul>
      `
    },
  ],
  resultados: [
    {
      key: "metodologia_li",
      name: "Descrição das etapas",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 50000 } }],
      counter: 50000,
      maxLength: 50000,
      ajudaComplexo: `
      <p>Apresentar de <b>forma técnica e detalhada</b> cada uma das atividades desenvolvidas ao longo do ano base, evidenciar o esforço da equipe na resolução (ou tentativa) de cada um dos desafios tecnológicos apresentados o projeto foi feito, sempre especificando os aspectos de P&D. <b>As atividades <u>NÃO</u> podem ser descritas de forma genérica.</b> Essa descrição deve ser dividida em macro etapas e as atividades que as compõe, apresentando:</p>
      <ul>
        <li>O que foi feito e como foi feito em cada uma das atividades de forma detalhada e técnica, trazendo o processo de desenvolvimento do produto/processo/serviço em questão; pesquisas e estudos realizados; qual abordagem foi utilizada para resolver o(s) desafio(s).</li><br>
        <li>Detalhar <b>testes</b> realizados para comprovação do correto funcionamento da solução, descrevendo detalhar quais foram esses testes, como foram feitos, quais os <b>resultados</b> obtidos e o que os resultados evidenciam para o desenvolvimento do projeto;</li><br>
        <li>Se foram construídos <b>protótipos</b>, também detalhar quantos foram, como foi a sua construção;</li><br>
        <li>Detalhar os <b>resultados</b> obtidos em cada uma das atividades.</li><br>
        <li>Comentar sobre novos conhecimentos adquiridos em razão do projeto; homologação final do projeto (caso o projeto ainda não tenha sido finalizado, é preciso comentar sobre as etapas que deverão ser realizadas no ano imediatamente subsequente).</li><br>
        <li>Apresentar as competências que foram exigidas para execução do projeto. As competências referem-se as qualificações, tipos de profissionais envolvidos no projeto, bem como o detalhamento do uso de terceiros (Universidades, ICTs, etc.) quando aplicável.</li><br>
        <li>Se o projeto for ter continuidade, apresentar de forma resumida quais as atividades têm previsão de serem desenvolvidas no ano seguinte, dando continuidade ao projeto.</li><br>
      </ul>
      <p><b>Segue formato de preenchimento das atividades de desenvolvimento do projeto:</b></p>
      <ul>
        <span>ME 1: (título da macro etapa)</span><br>
        <span>Atividade 1: (nome/nº da macro etapa/atividade)</span><br>
        <span>Descrição: (descrever o que foi feito na etapa)</span><br>
        <span>Resultado da atividade: (o que foi definido/concluído nesta etapa) ex: Cronogramas atualizados, relatórios de acompanhamento do projeto, Relatório de testes, Protótipo, Desenhos, Desenvolvimento de algo específico...</span><br>
        <span>Período: dd/mm/aaaa a dd/mm/aaaa</span><br>
        <span>Participantes: João, Maria, Mateus...</span><br><br>

        <span>Atividade 2: (nome/nº da macroetapa/atividade)</span><br>
        <span>Descrição: (descrever o que foi feito na etapa)</span><br>
        <span>Resultado da atividade: (o que foi definido/concluído nesta etapa) ex: Cronogramas atualizados, relatórios de acompanhamento do projeto, Relatório de testes, Protótipo, Desenhos, Desenvolvimento de algo específico...</span><br>
        <span>Período: dd/mm/aaaa a dd/mm/aaaa</span><br>
        <span>Participantes: João, Maria, Mateus...</span><br><br>

        <span>ME 2: (título da macro etapa)</span><br>
        <span>Atividade 3: (nome/nº da macroetapa/atividade)</span><br>
        <span>Descrição: (descrever o que foi feito na etapa)</span><br>
        <span>Resultado da atividade: (o que foi definido/concluído nesta etapa) ex: Cronogramas atualizados, relatórios de acompanhamento do projeto, Relatório de testes, Protótipo, Desenhos, Desenvolvimento de algo específico...</span><br>
        <span>Período: dd/mm/aaaa a dd/mm/aaaa</span><br>
        <span>Participantes: João, Maria, Mateus...</span><br><br>
      </ul>
      `
    },
    {
      key: "resultado_li",
      name: "Resultados",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 50000 } }],
      counter: 50000,
      maxLength: 50000,
      ajudaComplexo: `
        <p>Neste campo é necessário apresentar de forma técnica e detalhada incluir características técnicas do projeto / Resultados obtidos com o projeto.</p>
        <p>Ex: O Projeto durante o ano de 2019, chegou até a construção dos protótipos, ou seja, teve as fases de: ... citar os resultados de cada etapa e resultado obtido no ano com o projeto.</p>
      `
    },
    {
      key: "informacoes_complementares_li",
      name: "Dados adicionais (não obrigatório, utilizado apenas dentro do projeto para informações adicionais)",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "max", params: { size: 150000 } }],
      counter: 150000,
      maxLength: 150000,
    },
  ],
};

export default fields;